import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIcon, Group, Text, Tooltip } from "@mantine/core";
import { useLocalStorage } from "@mantine/hooks";
import { IconLayoutSidebarLeftExpand, IconEdit, IconDownload, } from "@tabler/icons-react";
import { useCallback } from "react";
import { useChatHistoryOpen, useChatId } from "../../hooks/assistant.js";
import { useIntl } from "react-intl";
import { useAppAction, useAppSelector } from "../../hooks/redux.js";
import { toggleHistory } from "../../reducers/chatReducer.js";
import { Event } from "../../constants/events.js";
import { useCaptureEvent } from "../../components/StyleEditorContext.js";
import { useChatStore } from "../../hooks/useChatStore.js";
import { getInitStyle } from "../../reducers/initReducer.js";
import { useChatChangeStore } from "../../hooks/useChatChangeStore.js";
import { downloadJSON } from "../../utils/download.js";
export const ChatMessagesHeader = () => {
    const captureEvent = useCaptureEvent();
    const open = useChatHistoryOpen();
    const intl = useIntl();
    const toggle = useAppAction(toggleHistory);
    const style = useAppSelector(getInitStyle);
    const styleId = style.id;
    const chatId = useChatId();
    const { summary, messages } = useChatStore(styleId, chatId);
    const { newChat } = useChatChangeStore(styleId);
    const hasMessages = messages.length > 0;
    const [showExportChat] = useLocalStorage({
        key: "mapka-showExportChat",
        defaultValue: false,
        getInitialValueInEffect: false,
    });
    const handleExportChat = useCallback(() => {
        captureEvent(Event.ExportChat);
        downloadJSON(messages, `chat-messages-${chatId}.json`);
    }, [hasMessages, captureEvent, messages, chatId]);
    const handleToggleChatList = useCallback(() => {
        captureEvent(Event.ToggleChatHistory);
        toggle();
    }, [captureEvent, toggle]);
    const handleStartNewChat = useCallback(() => {
        if (!hasMessages)
            return;
        captureEvent(Event.CreateNewChat);
        void newChat();
    }, [hasMessages, captureEvent, newChat]);
    const labelExpand = intl.formatMessage({
        defaultMessage: "Expand chat history",
        id: "button.expandChatHistory",
    });
    const startChatLabel = intl.formatMessage({
        defaultMessage: "Start new chat",
        id: "button.startNewChat",
    });
    const exportChatLabel = intl.formatMessage({
        defaultMessage: "Export chat",
        id: "button.exportChat",
    });
    const chatTitle = summary || intl.formatMessage({
        defaultMessage: "New chat",
        id: "label.newChat",
    });
    return (_jsxs(Group, { w: "100%", justify: "space-between", pb: "xs", children: [!open && (_jsx(Tooltip, { label: labelExpand, children: _jsx(ActionIcon, { variant: "subtle", color: "light-dark(black, white)", onClick: handleToggleChatList, "aria-label": labelExpand, children: _jsx(IconLayoutSidebarLeftExpand, { size: 24 }) }) })), _jsx(Text, { size: "md", ta: "center", flex: 1, truncate: true, children: chatTitle }), showExportChat && hasMessages && (_jsx(Tooltip, { label: exportChatLabel, children: _jsx(ActionIcon, { variant: "subtle", color: "light-dark(black, white)", onClick: handleExportChat, "aria-label": exportChatLabel, children: _jsx(IconDownload, { size: 24 }) }) })), _jsx(Tooltip, { label: startChatLabel, children: _jsx(ActionIcon, { variant: "subtle", color: "light-dark(black, white)", onClick: handleStartNewChat, "aria-label": startChatLabel, children: _jsx(IconEdit, { size: 24 }) }) })] }));
};
